var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-post",
    class: {
      last: _vm.isLast, 'has-long-price': _vm.priceArray.length > 1
    }
  }, [_c('div', {
    staticClass: "menu-post-desc"
  }, [_c('h4', [_c('span', {
    staticClass: "menu-title",
    style: ({
      backgroundColor: null
    })
  }, [_vm._v(_vm._s(_vm._f("preposFix")(_vm.name)))]), _vm._v(" "), _c('span', {
    staticClass: "menu-dots"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-price nowrap",
    style: ({
      backgroundColor: null
    })
  }, _vm._l((_vm.priceArray), function(p, i) {
    return _c('span', [(i !== 0) ? _c('span', [_c('smp-hair'), _vm._v("/"), _c('smp-hair')], 1) : _vm._e(), _vm._v(_vm._s(p)), _c('smp-hair'), _vm._v("€")], 1)
  }))]), _vm._v(" "), (_vm.text || _vm.allergens.length > 0 || _vm.weight) ? _c('div', {
    staticClass: "menu-text"
  }, [_vm._v("\n        " + _vm._s(_vm._f("preposFix")(_vm.text)) + "\n        "), _c('span', {
    staticClass: "nowrap"
  }, [(_vm.weight) ? _c('span', {
    staticClass: "b"
  }, [_vm._v(" " + _vm._s(_vm.weight))]) : _vm._e(), _vm._v(" "), (_vm.allergens.length > 0) ? _c('span', {
    staticClass: "nowrap",
    attrs: {
      "title": ("alergény: " + _vm.allergensText)
    }
  }, [_vm._v("[" + _vm._s(_vm.allergens.join(', ')) + "]")]) : _vm._e()])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9689df68","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItem.vue
// module id = 102
// module chunks = 1